import {nothingSelector} from 'services/utils/selectors/nothingSelector';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditEditedWorkSelector} from '../metadataEditSlice';
import type {WorkV4} from '../types';

export const useConditionalWorkEdit = (required: boolean): WorkV4 | undefined =>
  useAppSelector(
    required ? selectMetadataEditEditedWorkSelector : nothingSelector,
  );
